import { all } from 'redux-saga/effects';

import AuctionSaga from './auction/AuctionSagas';
import authSaga from './auth/AuthSagas';
import carrierRegistrationdSaga from './CarrierRegistration/CarrierRegistrationSagas';
import OverChargeClaimsSaga from './Claims/OverCharge/OverChargeSagas';
import commonSaga from './common/CommonSagas';
import dashboardSaga from './Dashboard/DashboardSagas';
import LookupsSaga from './lookups/LookupsSagas';
import POShipmentDraftSearchSaga from './POShipmentDraftSearch/POShipmentDraftSearchSagas';
import POShipmentPreBookingSearchSaga from './POShipmentPreBookingSearch/POShipmentPreBookingSearchSagas';
import POShipmentSearchSaga from './POShipmentSearch/POShipmentSearchSagas';
import POVSagas from './POV/POVSagas';
import procurementProjectSaga from './Procurement/Project/ProcurementProjectSagas';
import procurementLaneSaga from './Procurement/RouteConfig/Lane/ProcurementLaneSagas';
import procurementLocationSaga from './Procurement/RouteConfig/Location/ProcurementLocationSagas';
import procurementZoneSaga from './Procurement/RouteConfig/Zone/ProcurementZoneSagas';
import procurementTenderSaga from './Procurement/Tender/ProcurementTenderSagas';
import PurchaseOrderSagas from './purchaseOrder/PurchaseOrderSagas';
import RateShopSaga from './RateShop/RateShopSagas';
import routguideSaga from './RoutingGuide/RoutingGuideSagas';
import saversSaga from './Savers/SaversSagas';
import shipmentSaga from './shipment/ShipmentSagas';
import visibilitySaga from './visibility/VisibilitySagas';

export default function* rootSaga() {
  yield all([
    commonSaga(),
    authSaga(),
    dashboardSaga(),
    carrierRegistrationdSaga(),
    shipmentSaga(),
    PurchaseOrderSagas(),
    POVSagas(),
    AuctionSaga(),
    visibilitySaga(),
    LookupsSaga(),
    RateShopSaga(),
    procurementProjectSaga(),
    procurementTenderSaga(),
    POShipmentSearchSaga(),
    procurementLocationSaga(),
    procurementZoneSaga(),
    procurementLaneSaga(),
    POShipmentDraftSearchSaga(),
    POShipmentPreBookingSearchSaga(),
    OverChargeClaimsSaga(),
    routguideSaga(),
    saversSaga(),
  ]);
}
